// Compared against current-loop earned Hov (`runBaseHov`), never against
// historical max Hov reached during the NHov interval.
export const NHOV_BASE_HOV_THRESHOLD = "1e22";

export const NHOV_BASE_HOV_THRESHOLD_VALUE = Number(NHOV_BASE_HOV_THRESHOLD);
